import ApplicationController from '../application_controller'

class WorkingHoursController extends ApplicationController {
  static targets = ['hours', 'totalHours']

  async connect () {
    this.numbro = (await import('numbro')).default
    this.formatHours()
    this.updateTotalHours()
  }

  defaultFormat (value) {
    return this.numbro ? this.numbro(value).format({ mantissa: 2 }) : value
  }

  hoursTargetConnected (element) {
    const updateValueAndTotal = (event) => {
      if (event.target.value.length > 4) {
        event.target.value = this.defaultFormat(event.target.value)
      }
      this.updateTotalHours()
    }

    element.addEventListener('change', updateValueAndTotal)
    element.addEventListener('keyup', updateValueAndTotal)
  }

  formatHours () {
    this.hoursTargets.forEach(element => {
      element.value = this.defaultFormat(element.value)
    })
  }

  updateTotalHours () {
    const sum = this.hoursTargets.reduce((acc, element) => {
      return acc + parseFloat(element.value) || 0
    }, 0)

    this.totalHoursTarget.value = this.defaultFormat(sum)
  }
}

export default WorkingHoursController
